import React, {
  Component
} from 'react';
import {
  connect
} from 'react-redux';
import classes from './IpReservations.css';
import Box from '../../hoc/Box/Box';
import * as actions from '../../store/actions/index';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import Spinner from '../../components/UI/Spinner/Spinner';
import DeviceIcon from '../../components/UI/DeviceIcon/DeviceIcon';
import Modal from '../../components/UI/Modal/Modal';
import api from '../../axios-local-api';
import Collapsible from 'react-collapsible';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import ACDevice from './ACDevice/ACDevice';
import Success from '../../components/UI/Success/Success';
import Error from '../../components/UI/Error/Error';
import { 
  getDeviceName, 
  getDeviceModel, 
  getDeviceIconUrl,
  getSoftwareVersion,
  getDeviceSignalStatus,
  getDevicePauseStatus,
  getGroupMap,
  getGroupName
} from '../../shared/common';
import SlidePanel from '../../components/UI/SlidePanel/SlidePanel';
import DeviceDetails from '../DeviceList/DeviceDetails/DeviceDetails';
import ErrorAlert from '../../shared/Alert/ErrorAlert';

export class IpReservations extends Component {

  constructor(props) {
    super(props);
    this.resetUpArrows = this.resetUpArrows.bind(this);
    this.updateScheduleDetails = this.updateScheduleDetails.bind(this);
  }

  state = {
    upArrows: [],
    adding: false,
    upArrowsM: false,
    upArrowsCreate: false,
    dhcpReset: false,
    showIP: null,
    success: false,
    error: false,
    loadedAdvancedDeviceIds: false,
    status: '',
    showDeets: null,
    deviceIconUrl: null,
    deviceAdding: false,
    showDeets: null,
    deviceIconUrl: null,
    updatedCustomSchedule: false
  }
  componentDidMount() {
  }
  componentWillUpdate() {

  }
  componentDidUpdate() {
    if (!this.state.loadedAdvancedDeviceIds) {
      //this.loadAdvancedDeviceIds();
      if (this.props.devicesByEquipment) {
        //let deviceMacs = ["a8:be:27:52:e9:26", "30:93:bc:ae:3a:40"];
        let deviceMacs = this.props.devicesByEquipment.map(d => d.mac);
        //console.log("deviceMacs", deviceMacs);
        if (deviceMacs.length > 0) {
          this.setState({
            loadedAdvancedDeviceIds: true
          });
          this.props.onGetAdvancedDeviceIds(deviceMacs);
        }

      }

    }

    if (this.props.devicesByEquipment && this.state.showDeets && this.state.showDeets.mac) {
      this.props.devicesByEquipment.map((d) => {
        if (d.mac === this.state.showDeets.mac) {
          if (d.freeze.frozen !== this.state.showDeets.freeze.frozen
            || d.name !== this.state.showDeets.name
            || d.freeze.timeTemplates.length !== this.state.showDeets.freeze.timeTemplates.length
            || this.state.updatedCustomSchedule && this.props.success ||
            (this.state.showDeets.steering !== d.steering)
          ) {
            this.setState({
              showDeets: d,
              updatedCustomSchedule: false
            })
            this.getAdvancedDeviceHandler(d);
          }
        }
      });
    }

  }
  componentWillReceiveProps(nextProps) {
    // if (nextProps.error && !this.state.error) {
    //   this.setState({ error: true })
    //   this.props.onResetDhcpErrorSuccess()
    // }
    // if (nextProps.success && !this.state.success) {
    //   this.setState({ success: true })
    //   this.props.onResetDhcpErrorSuccess()
    // }
  }
  openHandlerCreate() {
    this.setState({
      upArrowsCreate: true
    })
  }
  closeHandlerCreate() {
    this.setState({
      upArrowsCreate: false
    })
  }
  openHandlerM() {
    this.setState({
      upArrowsM: true
    })
  }
  closeHandlerM() {
    this.setState({
      upArrowsM: false
    })
  }
  openHandler(ind, element) {
    //find portForwards in device by element mac
    this.setState({
      upArrows: this.state.upArrows.concat(ind)
    })
  }
  closeHandler(ind) {
    this.state.upArrows.splice(this.state.upArrows.indexOf(ind), 1)
    this.setState({
      // upArrows:this.state.upArrows.splice(this.state.upArrows.includes(ind), 0 )
      upArrows: this.state.upArrows
    })
  }
  resetDhcp = () => {
    this.setState({ dhcpReset: true, upArrows: [] });
    setTimeout(() => {
      this.setState({ dhcpReset: false });
    }, 1)

  }
  showDeviceIP = (e) => {
    // this.props.onSetFromLogDetailsPage();
    //console.log('what is e',e)
    this.setState({
      showIP: e,
      adding: true,
    });

  }
  modalCancelHandler = () => {
    this.setState({
      adding: false,
      deviceAdding: false
      //editing: false
    });
  }
  successErrorResetHandler = () => {
    this.setState({ error: false, success: false });
    this.props.onResetDhcpErrorSuccess()
  }

  getDeviceIconUrl = (deviceMAC) => {

    //console.log("Activity.getDeviceIconUrl", deviceMAC);
    if (!deviceMAC) {
      return undefined;
    }
    if (!this.props.devices || !this.props.devices.advancedDeviceIds) {
      return undefined;
    }
    let adid = this.props.devices.advancedDeviceIds[deviceMAC];
    //console.log("adid", adid);
    if (!adid) {
      return undefined;
    }
    let icons = adid.deviceIcons.icons;
    return icons['3x'] || icons['2x'] || icons['1x'];
  }
  resetUpArrows() {
    this.setState({
      upArrows: false,
    });
  }

  updateScheduleDetails() {
    this.setState({
      updatedCustomSchedule: true
    })
  }

  getAdvancedDeviceHandler(element) {
    this.props.onGetAdvancedDevice(element.mac, 1);
  }

  showDeviceDetails = (element, deviceIconUrl) => {
    let device = this.props.devicesByEquipment.filter(
      (d) => d.mac === element.mac
    )[0];
    let status;
    if (
      device.connectionState &&
      device.connectionState === 'connected' &&
      device.freeze.frozen === true
    ) {
      status = 'Paused';
    } else if (device.health && device.health.status) {
      status =
      device.health.status.charAt(0).toUpperCase() +
      device.health.status.slice(1);
    } else {
      status = 'Disconnected';
    }
    let deviceModel = getDeviceModel(device.mac, 'fullName', this.props.advancedDeviceIds);
    let softwareVersion = getSoftwareVersion(device.mac, this.props.advancedDeviceIds);
    this.setState({
      showDeets: device,
      status: status,
      deviceAdding: true,
      deviceIconUrl: deviceIconUrl,
      deviceModel: deviceModel,
      softwareVersion: softwareVersion,
    });
    this.getAdvancedDeviceHandler(device);
  };

  render() {
// console.log(this.props, "test 239")

    let arrowM = (
      <MdKeyboardArrowDown
        color={'gray'}
        size={'30px'} />
    )
    if (this.state.upArrowsM) {
      arrowM = (
        <MdKeyboardArrowUp
          aria-label="arrow up"
          color={'gray'}
          size={'30px'} />

      )
    } else {
      arrowM = (
        <MdKeyboardArrowDown
          aria-label="arrow down"
          color={'gray'}
          size={'30px'} />

      )
    }
    let arrowCreate = (
      <MdKeyboardArrowDown
        color={'gray'}
        size={'30px'} />
    )
    if (this.state.upArrowsCreate) {
      arrowCreate = (
        <MdKeyboardArrowUp
          aria-label="arrow up"
          color={'gray'}
          size={'30px'} />

      )
    } else {
      arrowCreate = (
        <MdKeyboardArrowDown
          aria-label="arrow down"
          color={'gray'}
          size={'30px'} />

      )
    }
    let showDeviceIPModal;
    if (this.props.dhcpLoading || !this.props.dhcpLoaded || this.props.devicesLoading || !this.props.devicesLoaded || this.state.dhcpReset) {

      return (
        <Spinner />
      )
    } else if (this.props.errorStatus) {
      return (
        <ErrorAlert />
      )
    } else if (!this.props.realDevices) {
      return (
        <div id= 'advanceConfigNoDevice' style={{ color: 'gray', padding: '20px' }}>
          There is no Device Information available at this time
        </div>
      )
    } else if (this.props.realDevices && this.props.realDevices.length) {

      let deviceList = this.props.realDevices.map((element, ind, arr) => {
        let ipRes;
        if (this.props.realDhcp && this.props.realDhcp.length > 0) {
          ipRes = this.props.realDhcp.find((el) => {
            return el.mac === element.mac
          })

        }
        if (this.props.realBandwidth && this.props.realBandwidth.device && this.props.realBandwidth.device.length) {
          const bandwidthDevice = this.props.realBandwidth.device.find((mel) => {
            return (mel.deviceMAC === element.mac) ? mel : null;
          })
          // console.log('bandwidth device',bandwidthDevice)
          element.deviceIconReference = bandwidthDevice?.deviceIconReference || 'OTHER'

        } else {
          element.deviceIconReference = 'OTHER'
        }

        let arrow = (
          <MdKeyboardArrowDown
            color={'gray'}
            size={'30px'} />
        )
        if (this.state.upArrows.includes(ind)) {
          arrow = (
            <MdKeyboardArrowUp
              aria-label="arrow up"
              color={'gray'}
              size={'30px'} />

          )
        } else {
          arrow = (
            <MdKeyboardArrowDown
              aria-label="arrow downx"
              color={'gray'}
              size={'30px'} />

          )
        }
        var deviceName;
        if (
          !element.nickname ||
          element.nickname === undefined ||
          (element.nickname && !element.nickname.length) ||
          element.nickname === null
        ) {
          deviceName = element.name;
        } else {
          if (element.nickname.indexOf('|') !== -1) {
            deviceName = element.nickname.slice(
              element.nickname.indexOf('|') + 1,
              element.nickname.length
            );
          } else deviceName = element.nickname;
        }
    
        if (deviceName === undefined || deviceName.length === 0) {
    
          if (element.mac) {
            if (this.props.advancedDeviceIds && this.props.advancedDeviceIds[element.mac] && this.props.advancedDeviceIds[element.mac]['advancedDeviceId']) {
              if (this.props.advancedDeviceIds[element.mac]['advancedDeviceId']['modelAccuracyLevel']
                && this.props.advancedDeviceIds[element.mac]['advancedDeviceId']['modelAccuracyLevel'] > 4) {
                deviceName = this.props.advancedDeviceIds[element.mac]['advancedDeviceId']['model'] ? this.props.advancedDeviceIds[element.mac]['advancedDeviceId']['model'] : (this.props.advancedDeviceIds[element.mac]['advancedDeviceId']['type'] ? this.props.advancedDeviceIds[element.mac]['advancedDeviceId']['type'] : '');
              }
            }
            if ((deviceName === undefined || deviceName.length === 0) && this.props.advancedDeviceIds && this.props.advancedDeviceIds[element.mac] && this.props.advancedDeviceIds[element.mac]['advancedDeviceId']) {
              deviceName = this.props.advancedDeviceIds[element.mac]['advancedDeviceId']['dhcpHostname'];
            }
            if (deviceName === undefined || deviceName.length === 0) {
              deviceName = element.mac;
            };
          }
          if (deviceName === undefined || deviceName.length === 0) {
            deviceName = "Unknown";
          }
        }

        let deviceIconUrl = this.getDeviceIconUrl(element.mac);

        return (
          <div>

            <Collapsible
              key={ind}
              transitionTime={100}
              onOpening={
                () => { this.openHandler(ind, element) }

              }
              onClosing={
                () => { this.closeHandler(ind) }
              }
              trigger={
                (<Box >
                  <div className={classes.TableRow}>

                    <div className={classes.CellArea} style={{ display: 'flex' }}>
                      <DeviceIcon
                        iconUrl={deviceIconUrl}
                        size={30}
                      />
                  <span id='IPReservationsDeviceName'
                       style={{
                        padding: '6px 6px 6px 7px',
                        cursor: 'pointer',
                        // lineHeight: '1.5em',
                        // height: '2em',
                        // overflow: 'hidden',
                        whiteSpace: 'pre',
                        // textOverflow: 'ellipsis',
                        fontSize: '16px'
                      }}
                      className={[classes.devName, classes.RegularButton, classes.IpReservationsDeviceName].join(
                        ' '
                      )}
                      onClick={() => {
                        this.showDeviceDetails(
                          element,
                          deviceIconUrl
                        )
                      }
                       
                      }
                    >
                      {deviceName}
                    </span>
                      
                      {/* <div id='IPReservationsDeviceName' className={classes.IpReservationsDeviceName}>
                        {deviceName}
                      </div> */}
                    </div>

                    <div className={classes.CellAreaTiny}>
                      <button id="openArrow" className={classes.OpenCloseButton}>
                        {arrow}
                      </button>
                    </div>
                  </div>
                </Box>)
              }>

              <div className={classes.showDesktop}>
                <ACDevice
                  showOnMobile="false"
                  originalDevice={element}
                  originalIpRes={ipRes}
                  resetDevice={this.resetDevice}
                  resetDhcp={this.resetDhcp}
                  usedExternalPorts={this.props.externalPorts}
                />
              </div>
              <div className={classes.showMobile}>
                <ACDevice
                  showOnMobile="true"
                  originalDevice={element}
                  originalIpRes={ipRes}
                  resetDevice={this.resetDevice}
                  resetDhcp={this.resetDhcp}
                  usedExternalPorts={this.props.externalPorts}
                /></div>

            </Collapsible></div>

        )
      })
      // console.log('SHOW IP', this.state.showIP)
      let showDevIPModal;
      if (this.state.showIP && this.state.deviceAdding) {
        let ipResM;
        if (this.props.realDhcp && this.props.realDhcp.length > 0) {
          ipResM = this.props.realDhcp.find((el) => {
            return el.mac === this.state.showIP.mac
          })
        }
        showDevIPModal = (
          <div>

            <ACDevice
              showOnMobile="true"
              originalDevice={this.state.showIP ? this.state.showIP : null}
              originalIpRes={ipResM}
              resetDevice={this.resetDevice}
              resetDhcp={this.resetDhcp}
              usedExternalPorts={this.props.externalPorts}
            /></div>
        )
      }
      let deviceGroups = getGroupMap(this.props.deviceGroups);
      if (this.state.showDeets && this.state.deviceAdding) {

        let {deviceName} = getDeviceName(this.state.showDeets, this.props.advancedDeviceIds);
        let advancedDeviceIdsType;
       
        let bandwidthM;
        if (
          this.props.devicesByEquipment &&
          this.props.devicesByEquipment.length &&
          this.props.bandwidth &&
          this.props.bandwidth.device
        ) {
          bandwidthM = this.props.bandwidth.device.find(
            (dev) => dev.deviceMAC === this.state.showDeets.mac
          );
        } else {
          bandwidthM = null;
        }

        if (this.props.advancedDeviceIds && this.props.advancedDeviceIds[this.state.showDeets.mac] && this.props.advancedDeviceIds[this.state.showDeets.mac]['advancedDeviceId']) {
          advancedDeviceIdsType = this.props.advancedDeviceIds[this.state.showDeets.mac]['advancedDeviceId'].type;
        }

        let originalDevice = this.state.showDeets ? this.state.showDeets : null;
        let deviceGroupName = getGroupName(deviceGroups, originalDevice.mac);
        let groupFreezeTemplate = originalDevice.freeze || false;

        if (!deviceGroupName) {
          deviceGroupName = 'Ungrouped';
        } else {
          originalDevice.freeze = groupFreezeTemplate;
        }

        let status;

        if (this.state.showDeets && this.state.showDeets.connectionState &&
          this.state.showDeets.connectionState === 'connected' &&
          this.state.showDeets.freeze.frozen === true
        ) {
          status = 'Paused';
        } else if (this.state.showDeets && this.state.showDeets.health && this.state.showDeets.health.status) {
          status =
            this.state.showDeets.health.status.charAt(0).toUpperCase() +
            this.state.showDeets.health.status.slice(1);
        } else {
          status = 'Disconnected';
        }
        showDeviceIPModal = (
          <div>
            <DeviceDetails
              originalDevice={originalDevice}
              devName={deviceName}
              signalStatus={status}
              bandwidth={bandwidthM}
              isLoading={this.props.loading}
              resetUpArrows={this.resetUpArrows}
              devicesByEquipment={this.props.devicesByEquipment}
              resetDevice={this.resetDeviceHandler}
              modalCancel={this.modalCancelHandler}
              deviceIconUrl={this.state.deviceIconUrl}
              deviceModel={this.state.deviceModel}
              softwareVersion={this.state.softwareVersion}
              deviceGroupName={deviceGroupName}
              groupFreezeTemplate={groupFreezeTemplate}
              updateScheduleDetails={this.updateScheduleDetails}
              advancedDeviceIdsType={advancedDeviceIdsType}
              selectedEquipment={this.props.selectedEquipment}
            />
          </div>
        );
      }
      return (
        <Box>

          <div className={classes.IpReservations}>
            <div className={classes.showDesktop}>
              <div className={[classes.showDesktop, classes.TableRow].join(' ')} style={{ borderRadius: '5px 5px 0px 0px' }}>
                <div className={classes.Header}>
                  <b id="manageIPReservations">Manage IP Reservations</b>
                  <button id = 'GetReservations' className={classes.RegularButton} onClick={this.props.fetchPortForwarding}>
                    {!!this.props.portForwardingData ? 'Refresh' : 'Get Reservations'}
                  </button>
                </div>
              </div>
              {!!this.props.portForwardingData && deviceList}
            </div>
            <div className={[classes.showMobile].join(' ')} style={{ borderRadius: '5px 5px 0px 0px' }}>
              <div className={[classes.showMobile, classes.TableRow].join(' ')} style={{ borderRadius: '5px 5px 0px 0px' }}>
                <div className={classes.Header}>
                  <h3 id="manageIPReservations">Manage IP Reservations</h3>
                  <button className={classes.RegularButton} onClick={this.props.fetchPortForwarding}>
                    {!!this.props.portForwardingData ? 'Refresh' : 'Get Reservations'}
                  </button>
                </div>
              </div>
              {!!this.props.portForwardingData && deviceList}
            </div>

            <SlidePanel
            devDeets="true"
            show={this.state.deviceAdding}
            modalClosed={this.modalCancelHandler}
          >
            <button
              id='BackIpReservation'
              className={classes.RegularButton}
              style={{ marginTop: '2px' }}
              onClick={this.modalCancelHandler}
            >
              {'<'} Return to IP Reservations
            </button>
            {showDeviceIPModal}
            
          </SlidePanel>
          <Modal
              show={this.props.error}
              modalClosed={this.successErrorResetHandler}
            >
              <Error id={'DeviceDetailsError'} />
              </Modal>
            <Modal
              show={this.props.success}
              modalClosed={this.successErrorResetHandler}
            >
              <Success id={'DeviceDetailsSuccess'} />
            </Modal>

            <Modal ipResDev="true" show={this.state.adding} modalClosed={this.modalCancelHandler}>
              <h3 className={classes.RegularButton} style={{ marginTop: '2px' }} onClick={this.modalCancelHandler}>{'<'} Back To Manage IP Reservations</h3>
              <div className={classes.Separator} />
              {showDevIPModal}
            </Modal>


          </div>

        </Box>
      )
    } else {
      return (
        <div id= 'advanceConfigNoDevice' style={{ color: 'gray' }}>
          There is no Device Information available at this time
        </div>
      )
    }
  }
}


const mapStateToProps = (state => {
  return {
    dhcpLoading: state.dhcp.loading,
    dhcpLoaded: state.dhcp.loaded,
    devices: state.devices,
    devicesLoading: state.devices.loading,
    devicesLoaded: state.devices.loaded,
    isAuthenticated: state.auth.token !== null, isPinxt: state.auth.pToken !== null,
    realSettings: state.settings.realSettings,
    isDummy: state.auth.isDummy,
    realDhcp: state.dhcp.realDhcp,
    realDevices: state.devices.realDevices,
    errorStatus: state.devices.errorStatus,
    devicesByEquipment: state.devices.devicesByEquipment,
    realBandwidth: state.bandwidth.realBandwidth,
    externalPorts: state.devices.externalPorts,
    success: state.dhcp.success,
    error: state.dhcp.error,
    advancedDeviceIds: state.devices.advancedDeviceIds,
    portForwardingData: state.portForwarding.showDeviceList,
    deviceGroups: state.deviceGroups.deviceGroups,
  };
});

const mapDispatchToProps = (dispatch) => {
  return {
    onResetDhcpErrorSuccess: () => dispatch(actions.resetDhcpErrorSuccess()),
    onGetAdvancedDeviceIds: (deviceMacs) => { dispatch(actions.getAdvancedDeviceIds(deviceMacs)) },
    fetchPortForwarding: () => { dispatch(actions.fetchPortForwarding()) },
    onGetAdvancedDevice: (deviceMac, days) => {
      dispatch(actions.getAdvancedDevice(deviceMac, days));
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(IpReservations, api));
